import { DialogContent, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

interface Props {
  modalState: UseModalState;
  email: string;
}

export function LoginConfirmationDialog(props: Props) {
  const { modalState, email } = props;
  const theme = getTheme();

  return (
    <ThemeProvider theme={theme}>
      <BottomSheet canDismiss modalState={modalState}>
        <BottomSheetIllustrationContent
          illustrationType="success"
          title="Check Your Email"
          description={`We sent a login link to ${email}`}
        />
        <DialogContent sx={{ paddingX: 5, paddingBottom: 12 }}>
          <Text variant="body1" sx={{ textAlign: "center" }}>
            Check your inbox to finish logging in.
          </Text>
        </DialogContent>
        <DialogFooter orientation="horizontal">
          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => {
              modalState.closeModal();
              logEvent(APP_V2_USER_EVENTS.CLOSE_LOGIN_CONFIRMATION_DIALOG);
            }}
          >
            Back to Log In
          </Button>
        </DialogFooter>
      </BottomSheet>
    </ThemeProvider>
  );
}
